// Vendors
import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
// Components
import { DownloadAppSKModalComponent } from 'components/download-app-sk-modal/download-app-sk-modal.component';
// Types
import type { DownloadAppSKModalContextType } from './types/download-app-modal.provider.type';

const DownloadAppSKModalContext = createContext<DownloadAppSKModalContextType | null>(null);

const DownloadAppSKModalProvider = ({ children }: PropsWithChildren): React.ReactElement => {
  const [openSKDownloadAppModal, setOpenSKDownloadAppModal] = useState(false);
  const [fetchingSK, setFetchingSK] = useState(false);
  const [errorSK, setErrorSK] = useState<boolean>(false);

  return (
    <DownloadAppSKModalContext.Provider
      value={{
        setFetchingSK,
        setErrorSK,
        setOpenSKDownloadAppModal,
      }}
    >
      {children}
      <DownloadAppSKModalComponent
        error={errorSK}
        fetching={fetchingSK}
        isOpen={openSKDownloadAppModal}
        onClose={() => setOpenSKDownloadAppModal(false)}
      />
    </DownloadAppSKModalContext.Provider>
  );
};

const useDownloadAppSKModalConsumer = (): DownloadAppSKModalContextType => {
  const context = useContext(DownloadAppSKModalContext);

  if (!context) {
    throw new Error(
      'useDownloadAppSKModalConsumer must be used within a DownloadAppSKModalProvider'
    );
  }

  return context;
};

export { DownloadAppSKModalProvider, useDownloadAppSKModalConsumer };
